export enum EQrCodeType {
	CREDENTIALS = "credentials",
	TEST_DEVICE = "test_device",
}
